import React from "react"

const Logo = props => (
  <svg viewBox="0 0 763.681 150" {...props} width="100%" height="40">
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="4"
      d="M150.87 5.823H99.531l.75 103.278h50.589"
    />
    <path
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M108.012 70.259h22.292"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="4"
      d="M666.062 110.005l32.65-102.903 32.425 102.903"
    />
    <path
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M694.997 70.259h22.292"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="4"
      d="M304.887 5.823h-51.339l.75 103.278h50.589"
    />
    <path
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M262.555 70.259h22.292"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="4"
      d="M509.487 6.16h-51.339l.751 103.279h50.588"
    />
    <path
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M466.48 70.259h22.292"
    />
    <path
      d="M171.946 111.16h-3.675V1.833l64.31 98.3V4.285h3.827v108.713l-64.462-98.301zM387.995 7.346a21.972 21.972 0 017.961 8.344 23.895 23.895 0 012.91 11.714 21.051 21.051 0 01-3.293 11.484 20.492 20.492 0 01-8.956 7.808 36.166 36.166 0 0119.674 11.638 30.326 30.326 0 017.732 20.517 32.538 32.538 0 01-16.077 28.327 31.047 31.047 0 01-15.923 4.287h-26.795V4.283h21.436a21.44 21.44 0 0111.33 3.063zm1.224 33.15a16.486 16.486 0 005.971-13.092q0-8.728-5.205-13.934a18.047 18.047 0 00-13.321-5.206h-17.761v37.36h15.924a21.338 21.338 0 0014.392-5.129zm6.813 63.16a28.645 28.645 0 0010.336-10.336 27.453 27.453 0 003.828-14.163 26.4 26.4 0 00-4.593-15.082 33.372 33.372 0 00-27.408-14.622h-19.292v58.03h22.967a27.433 27.433 0 0014.162-3.827zM434.54 4.283v107.182h-3.675V4.283zM530.445 3.607v103.507h46.088v3.675h-49.762V3.607zM602.209 104.85A32.51 32.51 0 01588.735 89l3.522-1.377a30.431 30.431 0 0012.478 14.163 37.043 37.043 0 0033.456 2.373 25.076 25.076 0 0010.489-8.345 21.08 21.08 0 003.905-12.632 19.022 19.022 0 00-9.11-16.843 67.98 67.98 0 00-20.288-8.88q-15.468-3.98-23.887-11.714-8.423-7.73-8.421-17.991a24.166 24.166 0 014.517-14.623 28.24 28.24 0 0112.096-9.417A41.317 41.317 0 01623.8.5a39.924 39.924 0 0119.676 5.053 30.228 30.228 0 0113.244 14.087l-3.368 1.53a28.36 28.36 0 00-11.944-12.708A36.488 36.488 0 00623.8 4.328q-12.403 0-20.747 6.354a20.059 20.059 0 00-8.346 16.767q0 10.719 8.422 16.766a66.41 66.41 0 0020.976 9.57q32.306 9.34 32.308 29.245a25.2 25.2 0 01-4.363 14.622 27.894 27.894 0 01-11.866 9.723 42.073 42.073 0 01-37.974-2.526zM4.175 3.608V110.79H.5V3.608zM65.726 8.202A34.398 34.398 0 0178.13 20.605a33.215 33.215 0 014.593 17.148 31.987 31.987 0 01-6.201 19.063 38.546 38.546 0 01-15.694 12.939L81.65 110.79h-4.134L57.305 71.133a40.415 40.415 0 01-12.862 2.143h-18.22v37.514h-3.676V3.608H48.73a32.928 32.928 0 0116.996 4.594zm-4.593 56.96A33.3 33.3 0 0073.84 53.83a28.57 28.57 0 004.747-16.078 29.882 29.882 0 00-4.058-15.158 30.671 30.671 0 00-10.948-11.178 28.635 28.635 0 00-15.005-4.134H26.222v62.012H44.29a36.053 36.053 0 0016.843-4.134z"
      stroke="#000"
      strokeMiterlimit="10"
    />
  </svg>
)

export default Logo
